(function () {

    /********************* Setup *********************/

        // find the section element via the script's data-id
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[id="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // section settings serialized by the liquid
    const settings = JSON.parse(section.querySelector(".productV44ASettingsJSON").textContent);

    // legacy single product, used for ATC when no option blocks are configured
    const fallbackProduct = JSON.parse(section.querySelector(".productV44AProductJSON").textContent);

    // cache the containers we query repeatedly
    const purchaseButton = section.querySelector(".productV44AContentPurchaseButton");
    const optionsRoot = section.querySelector(".productV44AContentOptions");
    const tasteNotes = section.querySelectorAll(".productV44AContentTasteNotesNote");

    // dynamic renews check — keep the original copy as a fallback when a combo has none
    const renewsText = section.querySelector('.productV44AContentChecksItem[data-dynamic-renews] .productV44AContentChecksItemText');
    const renewsFallback = renewsText ? renewsText.textContent.trim() : "";

    // dynamic sizing — keep the original copy as fallback
    const selectedSize = section.querySelector('.productV44AContentOptionsSelected');

    // combination map embedded from the buy_box_option blocks
    let combinations = [];
    if (optionsRoot) {
        combinations = JSON.parse(section.querySelector(".productV44AContentOptionsJSON").textContent);
    }

    // track the chosen value on each axis (seeded from the default-checked inputs)
    let selectedStrength = optionsRoot?.querySelector('.productV44AContentOptionsGroupItemInput[data-axis="strength"]:checked')?.dataset.value || null;
    let selectedFrequency = optionsRoot?.querySelector('.productV44AContentOptionsGroupItemInput[data-axis="size"]:checked')?.dataset.value || null;

    // default to the legacy single product so ATC still works when no option blocks are configured
    let activeVariantId = fallbackProduct.variantId;
    let activeSellingPlanId = fallbackProduct.sellingPlanId;

    // the one time cta can point at a separate product, so track it alongside the subscription variant
    let activeOtpVariantId = null;

    /********************* Gallery Swipers *********************/

        // auto height only works when a single carousel owns the space
    const canAutoHeight = section.querySelectorAll('.productV44AVisualGallerySwiper.flavor').length === 0;

    // init swiper(s)
    const swipers = section.querySelectorAll('.productV44AVisualGallerySwiper');
    swipers.forEach(function (swiper) {
        // start with keyboard control on the default carousel only; syncKeyboardControl() hands it to the active flavor carousel as the selection changes
        const keyboardEnabled = !swiper.classList.contains("flavor");
        new Swiper(swiper, {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: settings.auto_height_swiper === true && canAutoHeight,
            loop: true,
            breakpoints: {
                801: {
                    spaceBetween: 10,
                }
            },
            pagination: {
                el: swiper.querySelector('.swiper-pagination'),
                clickable: true,
            },
            keyboard: {
                enabled: keyboardEnabled,
                onlyInViewport: true, // Only control slider when it is visible on screen
            },
            navigation: {
                prevEl: swiper.querySelector('.swiper-button-prev:not(.onGallery)'),
                nextEl: swiper.querySelector('.swiper-button-next:not(.onGallery)'),
            },
        })
    })

    // event listeners for arrows on gallery
    section.querySelectorAll(".onGallery").forEach(arrow => {
        if (!arrow) return;
        arrow.addEventListener("click", () => {
            // check if this prev or next
            if (arrow.classList.contains("swiper-button-prev")) {
                arrow.closest('.productV44AVisualGallerySwiper')?.swiper?.slidePrev();
            } else {
                arrow.closest('.productV44AVisualGallerySwiper')?.swiper?.slideNext();
            }
        });
    });

    // give keyboard control to whichever carousel is currently visible, and remove it from the hidden ones
    function syncKeyboardControl() {
        section.querySelectorAll('.productV44AVisualGallerySwiper').forEach(el => {
            const isVisible = el.classList.contains('flavor')
                ? el.classList.contains('active')
                : !el.classList.contains('hideSwiper');
            if (isVisible) {
                el.swiper?.keyboard?.enable();
            } else {
                el.swiper?.keyboard?.disable();
            }
        });
    }

    // update swipers to show the correct carousel
    function updateSwipers() {
        // early guard: check for a match and its flavor
        const flavorSwipers = section.querySelectorAll('.productV44AVisualGallerySwiper.flavor');
        const match = combinations.find(combo => combo.strength === selectedStrength && combo.size === selectedFrequency);

        // get default swiper
        const defaultSwiper = section.querySelector(`.productV44AVisualGallerySwiper[data-type="default"]`);

        if (flavorSwipers.length === 0) {
            return;
        } else if (!match || !match.flavor) {
            flavorSwipers.forEach(swiper => swiper.classList.remove('active'));
            defaultSwiper.classList.remove('hideSwiper');
            syncKeyboardControl();
            return;
        }

        // get the swipers (we'll use a classlist toggle to show the correct one and hide the default to prevent overlap)
        flavorSwipers.forEach(flSwiper => flSwiper.classList.toggle('active', flSwiper.dataset.type === match.flavor));
        defaultSwiper.classList.toggle('hideSwiper', Array.from(flavorSwipers).some(el => el.classList.contains('active')));
        syncKeyboardControl();
    }

    /********************* Discount Code *********************/

        // check if discount code is present
    const discountCode = section.querySelector(".productV44AContentDiscountCode");
    if (discountCode && Cookies.get("discount_code")) {
        // set the discount code text
        discountCode.textContent = `${Cookies.get("discount_code").toUpperCase()} applied at checkout`;

        // show the discount code
        discountCode.classList.add("active");
    }

    /********************* Buy Box Options *********************/

    // sync the visible taste note to the checked strength option
    function updateNotes() {
        // exit if there are no taste notes
        if (tasteNotes.length === 0) {
            return;
        }

        // read the currently selected strength value once
        const currentStrength = section.querySelector('.productV44AContentOptionsGroupItemInput[data-axis="strength"]:checked')?.dataset.value;

        // show the matching note, hide the rest
        tasteNotes.forEach(note => {
            note.classList.toggle("active", note.dataset.value === currentStrength);
        });
    }

    // resolve the selected combination to a variant + selling plan, disabling purchase if none exists
    function updateSelection() {
        const match = combinations.find(combo => combo.strength === selectedStrength && combo.size === selectedFrequency);

        // check for the match before we update any content
        if (!match || !match.variantId) {
            purchaseButton.disabled = true;

            // still broadcast so size-driven sections track the selection even when the combo is unbuyable
            broadcastSelection();
            return;
        }

        // keep the renews copy in sync with the selection (runs even when no variant exists)
        if (renewsText) {
            // renews copy is frequency-driven, so fall back to any block sharing the frequency
            const renewsCombo = match && match.renewsText ? match : combinations.find(combo => combo.frequency === selectedFrequency && combo.renewsText);
            renewsText.textContent = renewsCombo ? renewsCombo.renewsText : renewsFallback;
        }

        // update selected size
        if (match.sellingPlanId) {
            selectedSize.textContent = `${selectedFrequency} · delivered monthly`;
        } else {
            selectedSize.textContent = ""
        }

        // if toggled, sync the version B with the selected strength
        if (settings.sync_pdps) {
            // very important, to make sure the content is up to date, click the v18a option to sync content
            const syncedItem = document.querySelector(`.productV43BContentOptionsGroupItemInput[data-axis="strength"][data-value="${selectedStrength}"]`);
            if (syncedItem) {
                syncedItem.click();
            }
        }

        purchaseButton.disabled = false;
        activeVariantId = match.variantId;
        activeSellingPlanId = match.sellingPlanId;
        activeOtpVariantId = match.otpVariantId || null;

        broadcastSelection();
    }

    // tell downstream sections (gifts display, etc.) which combination is active
    function broadcastSelection() {
        document.dispatchEvent(new CustomEvent("product:selection", {
            detail: {
                sectionId: section.id,
                strength: selectedStrength,
                size: selectedFrequency,
                variantId: activeVariantId,
                sellingPlanId: activeSellingPlanId,
            },
        }));
    }

    // update ATC - if dynamic ATC setting is enabled
    function updateATC(input) {
        // early guard: setting check and input axis type check
        if (settings.dynamic_atc === false || input.dataset.axis !== 'size') {
            return;
        }

        // get the needed elements we'll update
        const atcButton = section.querySelector('.productV44AContentPurchaseButtonText.dynamicATC') ?? null;
        const stickyAtcButton = section.querySelector('.productV44AStickyATCText.dynamicATC') ?? null;

        // read the price off the selected combination rather than scraping the rendered markup
        const match = combinations.find(combo => combo.strength === selectedStrength && combo.size === selectedFrequency);
        const priceText = match?.price ? price(match.price) : null;
        if (priceText != null) {
            [atcButton, stickyAtcButton].forEach(item => {
                if (item === null) return;
                item.innerHTML = `Start with ${selectedFrequency} <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.09277 3.4209C9.38362 3.13041 9.86145 3.13049 10.1523 3.4209L14.1992 7.46777C14.4902 7.75874 14.4902 8.23736 14.1992 8.52832L10.1523 12.5752C10.0031 12.7242 9.81216 12.7948 9.62305 12.7949C9.43376 12.7949 9.24209 12.7244 9.09277 12.5752C8.80181 12.2842 8.80181 11.8056 9.09277 11.5146L11.8594 8.74805H2.33594C1.92453 8.74805 1.58594 8.40945 1.58594 7.99805C1.58594 7.58664 1.92453 7.24805 2.33594 7.24805H11.8594L9.09277 4.48145C8.80181 4.19048 8.80181 3.71186 9.09277 3.4209Z" fill="#FFFCFC" stroke="white" stroke-width="0.5"/></svg> ${priceText}`
            })
        } else {
            [atcButton, stickyAtcButton].forEach(item => {
                if (item === null) return;
                item.innerHTML = settings.button_text;
            });
        }
    }

    if (optionsRoot) {
        // one delegated handler for both selector groups
        optionsRoot.addEventListener("change", function (e) {
            const input = e.target.closest(".productV44AContentOptionsGroupItemInput");
            if (!input) {
                return;
            }

            // store the chosen value for this axis
            if (input.dataset.axis === "strength") {
                selectedStrength = input.dataset.value;
            } else {
                selectedFrequency = input.dataset.value;
            }

            // move the active class onto the chosen card within this axis only
            optionsRoot.querySelectorAll(`.productV44AContentOptionsGroupItem[data-axis="${input.dataset.axis}"]`).forEach(item => item.classList.remove("active"));
            input.closest(".productV44AContentOptionsGroupItem").classList.add("active");
            updateSelection();
            updateNotes();
            updateATC(input);
            updateSwipers();
        });

        // initial resolve so ATC matches the default selection
        updateSelection();
        updateNotes();
        updateATC(section.querySelector(`.productV44AContentOptionsGroupItemInput:checked`));
        updateSwipers();

        // re-announce once the page is parsed — sections below this one don't exist yet during the initial resolve
        document.addEventListener("DOMContentLoaded", broadcastSelection);
    }

    /********************* Add To Cart *********************/

    // Function to add product to cart and redirect to checkout
    async function handleATC() {
        // the popup cta is the only path that can drop the subscription, and only when the shopper has picked the one time radio
        const isOneTime = this.classList.contains("productV44AContentPopupSub") && otpSelection === "otp";

        // the block can nominate its own one time product, otherwise the one time cta reuses the subscription variant
        let variantId = activeVariantId;
        if (isOneTime && activeOtpVariantId) {
            variantId = activeOtpVariantId;
        }

        // initialize form data with the currently selected variant
        let formData = {
            quantity: 1,
            id: variantId,
        };

        // attach the selling plan only when the product has one (subscription)
        if (activeSellingPlanId && !isOneTime) {
            formData.selling_plan = activeSellingPlanId;
        }

        // start loading
        this.classList.add("loading");

        // report which cta started this add, since the buy box, the sticky and the popup cta share the same handler
        let atcSource = "buy_box";
        if (this.classList.contains("productV44AStickyATC")) {
            atcSource = "sticky";
        } else if (this.classList.contains("productV44AContentPopupSub")) {
            atcSource = "otp_popup_sub";
            if (isOneTime) {
                atcSource = "otp_popup_once";
            }
        }
        trackATCSource(atcSource);

        // add product
        await addProduct(formData, true);

        // a dialog opened with showModal() sits in the top layer, so wait for it to actually close before the cart opens
        if (otpPopup?.open && otpPopup.contains(this)) {
            await closeOtpPopup();
        }

        // open the cart
        await openCart();

        // sleep for 200ms
        await sleep(200);

        // stop loading
        this.classList.remove("loading");
    }

    // ATC button
    purchaseButton.addEventListener("click", handleATC);

    /********************* Sticky ATC *********************/

    if (settings.show_sticky_cta) {
        // get sticky elements
        const stickyATC = section.querySelector('.productV44ASticky');
        const stickyPurchaseButton = section.querySelector('.productV44AStickyATC');

        // add a scrolling event listener
        window.addEventListener('scroll', function () {
            // if we scrolled past the PDP section and haven't reached the footer
            stickyATC.classList.toggle('sticky', window.scrollY > section.querySelector('.productV44AContentPurchaseButton').offsetTop && document.querySelector('#footerV2')?.getBoundingClientRect().top > document.documentElement.clientHeight)
        })

        // ATC button
        purchaseButton.addEventListener("click", handleATC);
        if (stickyPurchaseButton !== null && settings.sticky_atc_func === 'atc') {
            stickyPurchaseButton.addEventListener("click", handleATC);
        } else {
            stickyPurchaseButton.addEventListener("click", function () {
                window.scrollTo({
                    top: section.querySelector('.productV44AContentContainer')?.offsetTop - 70,
                    behavior: "smooth"
                })
            });
        }
    }

    /********************* Dropdowns *********************/

    // setup dropdowns
    if (section.querySelector('.productV44AContentDropdowns')) {
        section.querySelectorAll('.productV44AContentDropdownsItemTop').forEach(button => {
            button.addEventListener("click", function () {
                // if the button is already active, remove active class
                if (button.classList.contains('active')) {
                    button.classList.remove('active');
                    return;
                }
                // if no active class, add active class and close the other dropdowns
                section.querySelectorAll('.productV44AContentDropdownsItemTop').forEach(item => item.classList.remove('active'));
                button.classList.add('active');
            })
        })
    }

    /********************* OTP Popup *********************/

    const otpPopup = section.querySelector(".productV44AContentPopup");
    const otpSubColumn = otpPopup?.querySelector(".productV44AContentPopupCompareItem.sub");
    const otpOnceColumn = otpPopup?.querySelector(".productV44AContentPopupCompareItem.otp");
    const otpPopupText = otpPopup?.querySelector(".productV44AContentPopupTxt");

    // hold the merchant copy with its [savings] token intact, so each open can refill it for the combination on screen
    const otpPopupTextTemplate = otpPopupText ? otpPopupText.innerHTML : "";

    // hold the resolved prices so the radio can repaint the cta without recomputing the combination
    let otpSubCents = null;
    let otpOnceCents = null;

    // which column the shopper has picked — the cta adds a subscription until they switch to one time
    let otpSelection = "sub";

    // highlight the chosen column and point the cta at its copy and price
    function updateOtpSelection() {
        otpSubColumn.classList.toggle("active", otpSelection === "sub");
        otpOnceColumn.classList.toggle("active", otpSelection === "otp");

        let ctaText = settings.otp_popup_sub_atc;
        let ctaCents = otpSubCents;
        if (otpSelection === "otp") {
            ctaText = settings.otp_popup_otp_atc;
            ctaCents = otpOnceCents;
        }

        otpPopup.querySelector(".productV44AContentPopupATCTxt").textContent = ctaText;
        otpPopup.querySelector(".productV44AContentPopupATCPrice").textContent = ctaCents ? price(ctaCents) : "";
    }

    // close the popup and hand scrolling back to the page
    function closeOtpPopup() {
        // already on the way out, don't restart the animation
        if (otpPopup.classList.contains("closing")) {
            return Promise.resolve();
        }

        // close() yanks the dialog out of the top layer instantly, so let the exit animation run first
        otpPopup.classList.add("closing");

        return new Promise(function (resolve) {
            otpPopup.addEventListener("animationend", function handler(e) {
                // the mobile sheet animates too and its event bubbles up here
                if (e.target !== otpPopup) {
                    return;
                }
                otpPopup.removeEventListener("animationend", handler);
                otpPopup.classList.remove("closing");
                otpPopup.close();
                resolve();
            });
        });
    }

    if (otpPopup) {

        // Open popup
        section.querySelectorAll(".openOtp").forEach(function (element) {
            element.addEventListener("click", function () {
                // resolve the combination the shopper has selected right now
                const match = combinations.find(combo => combo.strength === selectedStrength && combo.size === selectedFrequency);
                
                // the subscription price has to come from the block settings — the selling plan allocation carries full price, the discount lands later
                otpSubCents = match?.price || null;

                // one time price comes from its own setting, falling back to the compare-at then the real variant price when a block leaves it blank
                otpOnceCents = match?.otpPrice || match?.compare || match?.variantPrice || fallbackProduct.variantPrice || null;

                // savings comes from the block setting, falling back to the gap between the compare at and the subscription price
                let otpSavings = match?.savings || null;
                if (!otpSavings && match?.compare && match?.price) {
                    otpSavings = Math.round((match.compare - match.price) / match.compare * 100);
                }

                // swap the merchant's [savings] token for the resolved percent
                if (otpPopupText) {
                    otpPopupText.innerHTML = otpPopupTextTemplate.replaceAll("[savings]", otpSavings ? `${otpSavings}%` : "");
                }

                // per cup maths only make sense when the frequency reads like "30 servings"
                const servings = parseInt(String(match?.size ?? selectedFrequency ?? "").match(/(\d+)\s*serving/i)?.[1], 10) || null;

                // column prices
                otpSubColumn.querySelector(".productV44AContentPopupCompareItemPriceReal").textContent = otpSubCents ? price(otpSubCents) : "";
                otpOnceColumn.querySelector(".productV44AContentPopupCompareItemPriceReal").textContent = otpOnceCents ? price(otpOnceCents) : "";

                // per cup breakdown under each column, with the one time column falling back to the maths when the block sets no override
                let oncePerText = otpOnceCents && servings ? `${price(otpOnceCents / servings)}/cup` : "";
                if (match?.otpPricePer) {
                    oncePerText = `${price(match.otpPricePer)}/cup`;
                }
                otpSubColumn.querySelector(".productV44AContentPopupCompareItemPer").textContent = otpSubCents && servings ? `${price(otpSubCents / servings)}/cup` : "";
                otpOnceColumn.querySelector(".productV44AContentPopupCompareItemPer").textContent = oncePerText;

                // the gap between the two, which the merchant's copy reads on from ("$16 more for the same bag...")
                otpPopup.querySelector(".productV44AContentPopupDiffPrice").textContent = otpSubCents && otpOnceCents && otpOnceCents > otpSubCents ? `+${price(otpOnceCents - otpSubCents)}` : "";

                // every open starts on the subscription, so reset the radio before painting the cta
                otpSelection = "sub";
                otpSubColumn.querySelector(".productV44AContentPopupCompareItemInput").checked = true;
                updateOtpSelection();

                otpPopup.showModal();
                document.querySelector("body").classList.add("noScroll");
            });
        });

        // the single cta adds the selected variant — handleATC drops the selling plan when the one time radio is picked
        otpPopup.querySelector(".productV44AContentPopupSub").addEventListener("click", handleATC);

        // the column radios drive both the highlight and what the cta adds
        otpPopup.querySelectorAll(".productV44AContentPopupCompareItemInput").forEach(function (element) {
            element.addEventListener("change", function () {
                otpSelection = this.value;
                updateOtpSelection();
            });
        });

        // close button
        section.querySelectorAll(".otpClose").forEach(function (element) {
            element.addEventListener("click", closeOtpPopup);
        });

        // backdrop exit
        otpPopup.addEventListener("click", function (e) {
            if (e.target === this) {
                closeOtpPopup();
            }
        });

        // escape closes a dialog natively and instantly, so route it back through the animated path
        otpPopup.addEventListener("cancel", function (e) {
            e.preventDefault();
            closeOtpPopup();
        });

        // catch the native closes too (escape key, form method="dialog")
        otpPopup.addEventListener("close", function () {
            document.querySelector("body").classList.remove("noScroll");
        });
    }

    /********************* Init *********************/

    // async IIFE: pull the live review count once the section is wired up
    (async () => {
        // update dynamic review count (if stars toggled)
        if (settings.hide_stars === false && settings.reviews_type === 'dynamic') {
            const reviewCount = await getReviewCount();
            section.querySelectorAll(".productV44AContentYotpoText").forEach(item => {
                item.textContent = `${reviewCount} Reviews`
            })
        }
    })();
}());
